<template>
  <v-card tile height="185" :elevation="elevation">
    <v-img v-if="item.newFlag" style="position:absolute;z-index:2;margin-top:-4px;margin-left:-4px;" :src="`${Utility.RES_SERVER}/static/img/badge-new.png`" width="38" contain></v-img>
    <v-img v-else-if="item.thirdFlag" style="position:absolute;z-index:2;margin-top:-4px;margin-left:-4px;" :src="`${Utility.RES_SERVER}/static/img/badge-third.png`" width="38" contain></v-img>
    <v-img v-else-if="item.betaFlag" style="position:absolute;z-index:2;margin-top:-4px;margin-left:-4px;" :src="`${Utility.RES_SERVER}/static/img/badge-beta.png`" width="38" contain></v-img>
    <a @click="onGoDetail">
      <v-card-text>
        <v-row dense>
          <v-col cols="auto">
            <v-img :src="Utility.RES_SERVER+item.logo" contain width="52"></v-img>
          </v-col>
          <v-col cols="8" class="pl-4">
            <v-row no-gutters>
              <v-col cols="12" class="text-h6 grey--text text--darken-3">{{item.name}}</v-col>
              <v-col cols="12" class="caption deep-orange--text">版本号：{{item.version}}</v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-2">
          <v-col cols="12" class="caption grey--text text--darken-3">{{item.note}}</v-col>
        </v-row>
      </v-card-text>
    </a>
    <v-card-actions style="position: absolute;bottom: 5px;right: 10px;">
      <v-spacer />
      <!-- <span class="caption red--text">点击量:</span>
      <span class="caption red--text font-weight-bold">999</span> -->
      <v-btn small text color="primary" class="ml-1 mt-0 pl-1 pr-1" @click="onFav">
        <v-icon color="red" small>{{!item.userFavId ? 'mdi-heart-outline' : 'mdi-heart'}}</v-icon>
        <span v-if="item.favNum>0" class="ml-1 red--text caption">{{item.favNum}}</span>
      </v-btn>
    </v-card-actions>

  </v-card>
</template>
<script>
import { writeVisitLog, favTool } from '@/plugins/api';
import { mapState } from 'vuex';

export default {
  props: ['item', 'elevation'],
  computed: {
    ...mapState({
      token: state => state.token
    })
  },
  data () {
    return {
      actionClick: false
    }
  },
  methods: {
    onGoDetail() {
      writeVisitLog(this.item.id);
      if (this.item.thirdFlag) {
        window.open(this.item.url, "_blank");
      } else {
        const { href } = this.$router.resolve({
          path: `/tool/${this.item.id}`,
        });
        window.open(href, "_blank");
      }
    },
    onFav () {
      if (!this.token) {
        this.$router.push('/login?redirect=/tool');
      } else {
        favTool(this.item.id).then((res) => {
          let msg = this.item.userFavId ? '取消收藏成功' : '加入收藏成功';
          this.$message.success(msg);
          this.item.favNum = res.data.favNum;
          this.item.userFavId = res.data.userFavId;
        })
      }
    }
  }
}
</script>